import { OAuth, OAuthBuilder } from '@ef/oauth-js-client';
import { env } from './environment'


export function createOauthClient(): OAuth {

  return new OAuthBuilder()
      .withFetchRequestor()
      .withNoHashQueryStringUtils()
      .build(env.clientId, env.clientSecret,env.openIdConnectUrl);
}

const oauth = new OAuthBuilder()
    .withFetchRequestor()
    .withNoHashQueryStringUtils()
    .build(env.clientId, env.clientSecret, env.openIdConnectUrl);

export default oauth;


export interface JWT {
  sub: string;
  groups: string[];
  exp: number
}
/**
 * this is a simplistic but functional&lightweight approach to parsing the jwt.
 *
 * There are better libraries that could be considered.
 */
export const parseJwt = (token: string | null): JWT => {
  if (!(token && token.includes('.'))) {
      throw new Error(`invalid jwt token: ${token}`);
  }
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
      window
          .atob(base64)
          .split('')
          .map(function (c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join('')
  );
  const json = JSON.parse(jsonPayload);
  return json;
};
